/**
 * 播放音频的样式重写
 */
"use strict";
angular.module("playAudioModule", []).
directive("playAudio", ["$timeout", function($timeout) {
	return {
		restrict: "E",
		replace: false,
		scope: {
			audioUrl: "=",
			isClose: "=" 
		},
		template: "<div class='playAudio'></div>",
		link: function(scope, element, attrs) {
			var audio = $("#my-player");
			scope.$watch("audioUrl", function(newVal, oldVal) {
				if(!newVal) return;
				initAudio(newVal);
			});
			/**
			 * 监听父页面是否关闭了音频播放
			 */
			scope.$watch("isClose", function(newVal, oldVal) {
				if(newVal) {
					videojs('my-player').dispose(); //销毁音频 这里必须要销毁 不然再次打开来 有问题 音频在继续播放
				}
			});

			function initAudio(newVal) {
				/**
				 * 给音频标签添加src
				 */
				var vhtml = "<audio id='my-player' class='video-js' controls preload='auto'>"+
							"	<source src='' type='audio/mp3'></source>"+
							"	<p class='vjs-no-js'>"+
							"		您的浏览器不支持audio标签"+
							"	</p>"+
							"</audio>";	
				$(".playAudio").html(vhtml);
				var source = document.getElementsByTagName('source')[0];
				source.src = newVal;
				var player = videojs('my-player', {
					fullscreenToggle: false,
					controlBar: {
						fullscreenToggle: false,
						currentTimeDisplay: true,
						timeDivider: true,
						durationDisplay: true,
						remainingTimeDisplay: false,
						volumePanel: {
							inline: false
						}
					}
				});
				player.language('zh-cn');
				player.play();
				player.pause();
				
			}
		}
	};
}]);